import React from "react";
var __jsx = React.createElement;
import { CDN_LINK } from "@globalConfig";
var SyarahLogo = function SyarahLogo(_ref) {
  var width = _ref.width,
    height = _ref.height,
    className = _ref.className,
    _ref$alt = _ref.alt,
    alt = _ref$alt === void 0 ? "syarah logo icon" : _ref$alt,
    id = _ref.id;
  return /*#__PURE__*/React.createElement("img", {
    width: width,
    height: height,
    className: className,
    src: CDN_LINK + "/assets/images/logoN.svg",
    alt: alt,
    id: id
  });
};
export default SyarahLogo;